<p-toast key="error-message" position="top-right"></p-toast>
<p-toast key="success-message" position="top-right"></p-toast>

<div class="p-d-flex p-jc-center p-ai-center" *ngIf="isLoading" style="min-height: 30vh;">
    <div class="p-text-center">
        <div>
            <i class="pi pi-spinner pi-spin p-text-center" style="font-size: 2rem"></i>
        </div>
        <div class="p-mt-5 p-text-secondary">
            Loading Roles !
        </div>
    </div>
</div>

<form [formGroup]="roleForm" *ngIf="!isLoading">
    <div class="p-grid p-jc-between p-mt-2">
        <div class="p-col-3">
            <span class="p-input-icon-right p-float-label width-100">
            <input *ngIf="!toggleDisabledField" type="text" pInputText formControlName="name"
                   class="width-100 p-text-bold" disabled="true"/>
                <input *ngIf="toggleDisabledField" type="text" pInputText formControlName="name"
                       class="width-100 p-text-bold"/>
                <label>Role</label>
                </span>
        </div>
        <div class="p-col-3 p-mr-3 p-as-center" [hidden]="!loggedInUser?.editRoles">
            <div class="p-grid p-ai-center p-jc-end">
                <div class="p-col-8">
                    <p-dropdown placeholder="Select.." emptyMessage="No roles found"
                                optionLabel="name"
                                formControlName="assignedParentRole"
                                [options]="adminRoles"></p-dropdown>
                </div>

                <div class="p-col-4 p-text-right">
                    <label>
                        Active
                    </label>
                    <p-inputSwitch formControlName="isActive"></p-inputSwitch>
                </div>
            </div>
        </div>
    </div>
</form>
<form>
    <div class="p-mx-4">
        <div class="p-grid p-mt-3 divider-bottom p-ai-center">
            <div class="p-col-3 divider-right p-mb-2">
                <h5>Modules</h5>
            </div>

            <div class="p-col-3 p-text-center divider-right p-mb-2">
                <h5>VIEW</h5>
            </div>

            <div class="p-col-3 p-text-center divider-right p-mb-2">
                <h5>EDIT</h5>
            </div>

            <div class="p-col-3 p-text-center p-mb-2">
                <h5>DELETE</h5>
            </div>
        </div>


        <div *ngFor="let roleConfigForm of roleFormArray?.controls">
            <div [formGroup]="roleConfigForm">
                <div class="p-grid divider-bottom p-py-3 p-ai-center">
                    <div class="p-col-3 divider-right">
                        {{roleConfigForm?.value?.label}}
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [formControl]="roleConfigForm.controls['isViewAllowed']"
                                    [disabled]="loggedInUser?.editRoles ? null  :'disabled'"
                                    binary="true"></p-checkbox>
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [formControl]="roleConfigForm.controls['isEditAllowed']"
                                    [disabled]="loggedInUser?.editRoles ? null  :'disabled'"
                                    binary="true"></p-checkbox>
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox
                                [formControl]="roleConfigForm.controls['isDeleteAllowed']"
                                [disabled]="loggedInUser?.editRoles ? null  :'disabled'"
                                binary="true"></p-checkbox>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="p-mt-5 p-d-flex p-ai-center p-jc-center p-mx-4">
        <div *ngIf="currentMode === 'update'">
            <button [disabled]="!loggedInUser?.editRoles" type="button" pButton pRipple
                    (click)="updateRoleConfig()"
                    label="Update"
                    class="p-button-secondary"></button>
        </div>
        <div *ngIf="currentMode === 'create'">
            <button type="button" pButton pRipple
                    (click)="createRoleConfig()"
                    label="Save"
                    class="p-button-secondary"></button>
        </div>
    </div>
</form>
